import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import PVOffering from "@/pages/PVOffering";

export const Route = createFileRoute("/es/servicios/farmacovigilancia/auditorias-fv-inspecciones-qms")({
  head: () => buildRouteHead("/es/servicios/farmacovigilancia/auditorias-fv-inspecciones-qms"),
  component: PVOffering,
});

